import iiotExport from '@/api/iiotExport'
export default function exportApi(exportCode,esayInfo) {
	return iiotExport({
		params: {
			exportCode:exportCode,
		},
		esayInfo: esayInfo,
	})
}
